import VueWrapper from '@/components/core/Vue/vue.wrapper';
import BackupHistoryComponent from '@/views/shared/backup-settings/backup-history.component';
import BackupRestoreComponent from '@/views/shared/backup-settings/backup-restore.component';
import BackupSettingsFormComponent from '@/views/shared/backup-settings/backup-settings-form.component';
import {Component, Prop} from 'vue-property-decorator';
import {BackupService} from '../services/backup.service';

@Component({
    components: {
        BackupHistoryComponent,
        BackupSettingsFormComponent,
        BackupRestoreComponent,
    },
})
export default class BackupSettingsDialogComponent extends VueWrapper {
    public $refs!: {
        backupSettingsForm: BackupSettingsFormComponent;
        backupHistory: BackupHistoryComponent;
        backupRestore: BackupRestoreComponent;
    };

    public activeTab: string = 'settings';

    @Prop({
        type: String,
        default: () => {
            return 'backup-settings-dialog';
        },
    })
    public readonly name!: string;

    public userId: string = '';

    public backupSrv: BackupService = new BackupService();

    public mounted() {
        this.userId = this.UserSessionSrv.userId || '';
        this.backupSrv.userId = this.userId;
        this.backupSrv.loadSettings(this.userId);
        this.backupSrv.loadBackups(this.userId);
    }

    public open() {
        if (this.CoreSrv.isModalOpened(this.name)) {
            this.close();
        }

        this.userId = this.UserSessionSrv.userId || '';
        this.backupSrv.userId = this.userId;
        this.backupSrv.loadSettings(this.userId);
        this.backupSrv.loadBackups(this.userId);
        this.reset();

        this.CoreSrv.OpenModal(this.name);
    }
    public close() {
        this.CoreSrv.CloseModal(this.name);
    }

    public reset() {
        this.activeTab = 'settings';
    }
}
